"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "veduggio-con-colzano": {
    "add85839": [{
      "hkey": "1873b088",
      "slug": "veduggio-con-colzano",
      "name": "Veduggio con Colzano",
      "primary": true,
      "skipSearch": false
    }],
    "brusco": [{
      "hkey": "1873b088",
      "slug": "veduggio-con-colzano",
      "name": "Veduggio con Colzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "87cb795a": [{
      "hkey": "1873b088",
      "slug": "veduggio-con-colzano",
      "name": "Veduggio con Colzano",
      "primary": true,
      "skipSearch": false
    }],
    "colzano": [{
      "hkey": "1873b088",
      "slug": "veduggio-con-colzano",
      "name": "Veduggio con Colzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e864e454": [{
      "hkey": "1873b088",
      "slug": "veduggio-con-colzano",
      "name": "Veduggio con Colzano",
      "primary": true,
      "skipSearch": false
    }],
    "tremolada": [{
      "hkey": "1873b088",
      "slug": "veduggio-con-colzano",
      "name": "Veduggio con Colzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ffd1b758": [{
      "hkey": "1873b088",
      "slug": "veduggio-con-colzano",
      "name": "Veduggio con Colzano",
      "primary": true,
      "skipSearch": false
    }],
    "veduggio": [{
      "hkey": "1873b088",
      "slug": "veduggio-con-colzano",
      "name": "Veduggio con Colzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;